





























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import moment from 'moment';

import { Parser } from 'json2csv';

moment.locale('pt-BR');

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
  },
  data: function() {
    return {
      examIdToGenerateReport: null,
      examIsBeingGenerated: false,
      searchingForExamGroup: false,
    };
  },
  computed: {
    ...mapGetters({
      examGroup: 'currentExamGroup',
      examResults: 'getExamResults',
    }),
  },
  methods: {
    async onGenerateReportClicked(examId) {
      this.examIsBeingGenerated = true;
      await this.$store.dispatch('PULL_EXAM_RESULTS', examId);
      this.downloadCSVWith(this.examResults);
      this.examIsBeingGenerated = false;
    },
    formatResults(examResults) {
      return examResults.results.map(result => {
        if (!result.score) {
          delete result.score;
        }
        delete result.__typename;
        return {
          ...result,
          totalQuestions: examResults.totalQuestions,
          start: moment(parseInt(result.start)).format('DD-MM-YYYY HH:MM'),
          end: moment(parseInt(result.end)).format('DD-MM-YYYY HH:MM'),
        };
      });
    },
    downloadCSVWith(examResults) {
      const json2csvparser = new Parser();
      const formattedResults = this.formatResults(examResults);
      let csv = json2csvparser.parse(formattedResults);
      const filename = examResults.name;
      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      const data = encodeURI(csv);
      let link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
    },
    async searchForExamGroup() {
      if (!this.examIdToGenerateReport) {
        alert('O campo de ID está nulo.');
        return null;
      }
      this.searchingForExamGroup = true;
      await this.$store.dispatch(
        'PULL_EXAM_GROUP',
        this.examIdToGenerateReport,
      );
      this.searchingForExamGroup = false;
    },
  },
});
